import { JSONContent } from '@tiptap/core';

import { extensions } from '@eluve/tiptap-extensions';

import { htmlToTiptapJson } from './htmlToTiptapJson';
import { markdownToHtml } from './markdownToHtml';

type NormalizeMarkdownReturn =
  | { ok: true; result: JSONContent }
  | { ok: false; error: Error };

export const markdownToTiptapJson = ({
  markdown,
}: {
  markdown: string;
}): NormalizeMarkdownReturn => {
  try {
    const html = markdownToHtml(markdown);
    const tiptapJson = htmlToTiptapJson({
      extensions: extensions,
      html,
    });
    return {
      ok: true,
      result: tiptapJson,
    };
  } catch (error) {
    return {
      ok: false,
      error: error as Error,
    };
  }
};
